import { byLang, type MdModule } from '../byLang';

export const pages = byLang(import.meta.glob<MdModule>('./*/*.md'));
